'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.keydownToggleWidget = function () {
	return mmWidgets.each(this, function () {
		const widget = this.domElements[0],
			key = widget.getAttribute('data-mm-keydown-toggle'),
			toggleClass = widget.getAttribute('data-mm-keydown-toggle-class'),
			invert = widget.hasAttribute('data-mm-keydown-toggle-invert'),
			processKeyEvent = function (evt) {
				if (!evt.key) {
					return;
				}
				if (evt.key.toUpperCase() !== key.toUpperCase()) {
					return;
				}
				const isDown = evt.type === 'keydown',
					shouldAdd = invert ? !isDown : isDown;
				if (shouldAdd) {
					toggleClass.split(' ').forEach(token => widget.classList.add(token));
				} else {
					toggleClass.split(' ').forEach(token => widget.classList.remove(token));
				}
			};
		widget.ownerDocument.addEventListener('keydown', processKeyEvent);
		widget.ownerDocument.addEventListener('keyup', processKeyEvent);
	});

};
